import React, { useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaChartPie, FaPlusCircle, FaMoneyBill, FaTasks, FaRegFilePdf, FaMoneyBillWave, FaReceipt, FaCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";
import { MdCheckCircle, MdAttachMoney, MdPerson, MdAccountBalanceWallet } from "react-icons/md";
import { IoMdSettings } from "react-icons/io";
import { FcSalesPerformance } from "react-icons/fc";

import { GlobalContext } from "../Context/GlobalState";
import { BASE_URL_API_TRANXT_UAT_API } from "../utils/Constant";
const iconMap = {
  "Employee Dashboard": <FaChartPie style={{ color: "Plum" }} />,
  "Perfomance": <FcSalesPerformance style={{ color: "#FEB941" }} />,
  "Salary Slip": <FaReceipt style={{ color: "#FEB941" }} />,
  "Loan Management": <FaMoneyBillWave style={{ color: "#A8DF8E" }} />,
  "Expense Tracking": <FaMapMarkerAlt style={{ color: "green" }} />,
  "Profile": <MdPerson style={{ color: "Aqua" }} />,
  "Attendance Management": <FaCalendarAlt style={{ color: "yellow" }} />,
  "Expense Management": <FaMoneyBill style={{ color: "Plum" }} />,
  "Contract": <MdAttachMoney style={{ color: "green" }} />,
  "Add Leave/WFH": <MdCheckCircle style={{ color: "#DAF7A6" }} />,
  "Leave Approval": <MdCheckCircle style={{ color: "#DAF7A6" }} />,
  "Create Work Space": <FaPlusCircle style={{ color: "orange" }} />,
  "Work Dashboard": <FaChartPie style={{ color: "Plum" }} />,
  "Task Overview": <FaTasks style={{ color: "pink" }} />,
  "File": <FaReceipt style={{ color: "#FEB941" }} />,
  "Policy": <FaRegFilePdf style={{ color: "red" }} />,
  "EPF": <MdAccountBalanceWallet style={{ color: "pink" }} />,
  "Settings": <IoMdSettings style={{ color: "yellow" }} />,
};

const employeeLinks = [
  {
    to: "/Employee/dashboard",
    name: "Employee Dashboard",
    moduleName: "Profile Management",
    roleName: "View Profile",
  },
  { to: "/Employee/performance", name: "Perfomance" },
  { to: "/Employee/salary-slip", name: "Salary Slip" },
  { to: "/Employee/loan-management", name: "Loan Management" },
  { to: "/Employee/expense-tracking", name: "Expense Tracking" },
  { to: "/Employee/profile", name: "Profile" },
  {
    to: "/Employee/attendance-management",
    name: "Attendance Management",
    moduleName: "Attendance Management",
    roleName: "View Attendance",
  },
  { to: "/Employee/expense-management", name: "Expense Management" },
  // { to: "/Employee/Contract", name: "Contract" },
  { to: "/Employee/add-leave-wfh", name: "Add Leave/WFH" },
  {
    to: "/Employee/Leave-approval",
    name: "Leave Approval",
    moduleName: "Leave Approval",
    roleName: "Leave Approval",
  },
  { to: "/Employee/create-workspace", name: "Create Work Space" },
  {
    to: "/Employee/work-dashboard",
    name: "Work Dashboard",
    moduleName: "Workspace Management",
    roleName: "View Workspace",
  },
  {
    to: "/Employee/task-overview",
    name: "Task Overview",
    moduleName: "Task Overview",
    roleName: "Task Overview",
  },
  { to: "/Employee/file", name: "File" },
  {
    to: "/Employee/policy",
    name: "Policy",
    moduleName: "Policy Management",
    roleName: "View Policy",
  },
  { to: "/Employee/EPF", name: "EPF" },
  { to: "/Employee/setting", name: "Settings" },
];

const EmployeeSidebar = () => {
  const { pathname } = useLocation();
  const { user, accessDataemp, setAccessemployeData } =
    useContext(GlobalContext);

  const fetchAccessData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetAccessManagementAdmin`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ firmid: user.firm_id, empid: user.userid }),
        },
      );
      const data = await res.json();
      if (data.status === "0") setAccessemployeData(data.data);
    } catch (e) {
      console.error(e);
    }
  };
  // useEffect(() => {
  //   console.log("ACCESS DATA ✅", accessDataemp);
  // }, [accessDataemp]);

  useEffect(() => {
    if (user?.firm_id && user?.userid) fetchAccessData();
  }, [user]);

  const navigationLinks = employeeLinks.filter((link) => {
    if (link.moduleName && link.roleName) {
      const moduleData = accessDataemp?.find((m) => m.module_name === link.moduleName);
      const dataArray = Array.isArray(moduleData?.data) ? moduleData.data : [];
      return !!dataArray.find((r) => r.role_name?.trim() === link.roleName?.trim() && r.access === "Y");
    }
    return true;
  });
  return (
    <div style={{ width: "220px", minHeight: "100vh", backgroundColor: "#212529", color: "white" }}>
      <ul className="list-unstyled p-3 mt-3 mb-0">
        <h5 className="mx-2">Employee System</h5>
        <hr className="m-1" />
        {navigationLinks.map((link) => {
          const access = link.access !== false;
          return (
            <li
              key={link.to}
              className={`p-2 d-flex align-items-center ${pathname === link.to ? "bg-light text-dark" : ""}`}
              style={{ opacity: access ? 1 : 0.5, pointerEvents: access ? "auto" : "none" }}
              title={access ? "" : "Access Denied"}
            >
              <Link
                to={access ? link.to : "#"}
                className="text-decoration-none d-flex align-items-center w-100"
                style={{ color: pathname === link.to ? "#000" : "#fff", fontSize: ".8rem", fontWeight: "200" }}
              >
                <span className="me-2" style={{ fontSize: ".9rem" }}>
                  {iconMap[link.name] || null}
                </span>
                {link.name}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default EmployeeSidebar;
